/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PricingPolicyType {
    ROLLUP = 'rollup',
    WEIGHTING = 'weighting',
    CUT_SELECTION = 'cutSelection',
}
